module.exports = __webpack_public_path__ + "static/Dallas_logo_animation-c69dd5840c112d06b6c41aebd7a52b5e.gif";